

const dataSlider = [
  {
    id: 0,
    title: "160 MVA 220 132 3 KV Autotransformer",
    img: "https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679767315/VishvasWebsite/SlideShowA/img1_fh6riz.png",

  },
  {
    id: 1,
    title: "132 KV Traction Substation at Dabhoi (Western Railway)",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679767310/VishvasWebsite/SlideShowA/img2_zvfoj7.png",
  },
  {
    id: 2,
    title: "21.6 30.24 MVA 132 27 KV Traction Power Transformer",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679767318/VishvasWebsite/SlideShowA/img3_zm9c7f.png",
  },
  {
    id: 3,
    title: "21.6 30.24 MVA 66 27 KV Traction Power Transformer",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679767310/VishvasWebsite/SlideShowA/img4_fcmsu8.png",
  },
  {
    id:4,
    title: "8 12.3 16.5 MVA 55 27.5 KV Autotransformers for 2 X 25 KV AC Traction System",
    img:"https://res.cloudinary.com/ddy8u7ff2/image/upload/v1679767313/VishvasWebsite/SlideShowA/img5_rx8ip3.png",
  },
];

export default dataSlider;
